var swiper = new Swiper(".mySwiper", {
    loop: true, 
    slidesPerView: 4,
    spaceBetween: 20,
    breakpoints:{
        0:{
            slidesPerView: 1,
            spaceBetween: 20,
        },
        580:{
            slidesPerView: 1,
            spaceBetween: 20,   
        },
        767:{   
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024:{
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1240:{
            slidesPerView: 4,
            spaceBetween: 20,
        }
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
  });
